import { title } from './constants';

import { Placeholder, PlaceholderChecklistsIcon } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import AddRoundedIcon from '@mui/icons-material/AddRounded';

import { TabPanelOptions } from '../../constants';

export interface EmptyStateProps {
  onClick: () => void;
  selectedPanel: TabPanelOptions;
  hasFilteredChecklists: boolean;
}

export const EmptyState = ({ onClick, selectedPanel, hasFilteredChecklists }: EmptyStateProps) => (
  <div className='w-full h-52 flex justify-center items-center'>
    <Placeholder
      className='flex flex-col max-w-72 [&>p]:text-center z-0'
      text={hasFilteredChecklists && selectedPanel === TabPanelOptions.RECEIVED_LISTS ? title.NO_FILTER_RESULTS : title[selectedPanel]}
      Icon={PlaceholderChecklistsIcon}
    >
      {selectedPanel === TabPanelOptions.CREATED_LISTS ? (
        <Button startIcon={<AddRoundedIcon />} onClick={onClick}>
          Criar Checklist
        </Button>
      ) : null}
    </Placeholder>
  </div>
);

export default EmptyState;
